import store from '@/store';
export default (to, from, next) => {
    if (to.name === 'no-addons-page') {
        return Promise.reject({ allow: true });
    }

    if (to.matched.some(record => record.meta?.profile === 'broadband')) {
        return Promise.resolve({ allow: true });
    }

    const isFWAProduct = store.getters.is_account_type_fwa;
    const isUFBProduct = store.getters.is_account_type_ufb;
    const isTravelMobile = store.getters.productType === 'travelMobile';
    const isMobileProduct = store.getters.is_mobile_product

    let allow

    if (isFWAProduct || isUFBProduct || isTravelMobile) {
        allow = true
    } else if (isMobileProduct) {
        allow = !store.getters.is_account_type_activated ||
                (store.getters.is_account_type_activated &&
                 (store.getters.customer_current_product_has_base_plan ||
                  store.getters.no_addons_notified))
    } else {
        allow = !store.getters.is_account_type_activated;
    }

    if (!allow) {
        if (!store.getters.is_enable_purchase_plans_and_addons) {
            return Promise.resolve({ allow: true });
        }

        return Promise.reject({
            allow: false,
            redirect: { name: 'no-addons-page' },
        })
    }

    return Promise.resolve({
        allow,
        redirect: { name: 'home' },
    })
};